<template>
  <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; z-index: 0;">
    <div class="container mt-4">
      <div class="mb-4 d-flex flex-column flex-sm-row align-items-start gap-2">
        <!-- Institute Dropdown -->
        <select v-model="selectedInstitute" class="form-select">
          <option value="">All Institutes</option>
          <option v-for="institute in institutes" :key="institute.id" :value="institute.id">
            {{ institute.institute_name }}
          </option>
        </select>
  
        <!-- Subject Dropdown -->
        <select v-model="selectedSubject" class="form-select">
          <option value="">All Subjects</option>
          <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
            {{ subject.name }}
          </option>
        </select>
  
        <!-- Grade Dropdown -->
        <select v-model="selectedGrade" class="form-select">
          <option value="">All Grades</option>
          <option v-for="grade in grades" :key="grade.id" :value="grade.id">
            Grade {{ grade.grade_level }}
          </option>
        </select>
  
        <!-- Search Student Name -->
        <input type="text" class="form-control" v-model="searchQuery" placeholder="Search Student Name" />
  
        <!-- Date Filter Dropdown -->
        <!-- Date Filter Dropdown -->
<select v-model="selectedDateFilter" class="form-select">
  <option value="all">All Dates</option>
  <option value="last">Last Payment</option>
  <option value="today">Today</option>
  <option value="last_week">Last Week</option>
  <option value="last_month">Last Month</option>
  <option disabled>──────────</option> <!-- separator line -->
  <option v-for="month in last12Months" :key="month.value" :value="month.value">
    {{ month.label }}
  </option>
</select>

      </div>

      
  <div class="p-3 mb-3 bg-primary text-white rounded shadow-sm">
  <h4 class="m-0">Student Payment Details</h4>
</div>

      <!-- <h2 class="mb-4 globeColor text-dark bg-light p-2 rounded">Student Payment Details</h2> -->

<div v-if="!loading" class="tagcard">
  <div class="row g-2">
    <div class="col-md-6 col-sm-12">
      <div class="alert alert-light border border-info py-2 px-3">
        <strong>Total Payments:</strong> {{ totalAllPayments }}
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="alert alert-light border border-info py-2 px-3">
        <strong>Total Filtered Payments:</strong> {{ totalFilteredPayments }}
      </div>
    </div>
  </div>

  <div class="row g-2 mt-1">
    <div class="col-md-6 col-sm-12">
      <div class="alert alert-light border border-info py-2 px-3">
        <strong>All payment Item Count:</strong> {{ allStudentItemCount }}
      </div>
    </div>
    <div class="col-md-6 col-sm-12">
      <div class="alert alert-light border border-info py-2 px-3">
        <strong>Filtered Payment Item Count:</strong> {{ filteredStudentItemCount }}
      </div>
    </div>
  </div>
</div>

      <!-- Loading Spinner -->
    <div v-if="loading" class="text-center my-4">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  
      <!-- Table -->
      <div v-if="!loading" class="table-responsive">
      <table class="table table-bordered table-hover align-middle text-nowrap">
        <thead class="table-dark">
          <tr>
            <th>Student Name</th>
            <th>Grade</th>
            <th>Subject</th>
            <th>Institute</th>
            <th>Payments</th>
          </tr>
        </thead>
        <tbody>

  
          <!-- Show student data when available -->
          <tr v-for="item in studentItems" :key="item.id">
            <td>{{ item.student.first_name }} {{ item.student.last_name }}</td>
            <td>{{ item.student.grade.grade_level }}</td>
            <td>{{ item.subject.name }}</td>
            <td>{{ item.student.institute.institute_name}}</td>
            <td class="desktop">
              <div>
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
  <tr v-if="item.payments.length === 0">
    <td colspan="2" class="text-center text-muted">No payment available</td>
  </tr>
  <tr v-else v-for="payment in item.payments" :key="payment.id">
    <td>{{ payment.payment_date }}</td>
    <td>{{ payment.amount }}</td>
  </tr>
  
</tbody>

                </table>
              </div>
            </td>


            <td class="mobile">
  <button 
    class="btn btn-sm btn-primary"
    data-bs-toggle="modal"
    data-bs-target="#paymentModal"
    @click="openPaymentModal(item)"
  >
    View
  </button>
</td>

          </tr>
  
          <!-- No data available message -->
  <tr v-if="!loading && studentItems.length === 0">
    <td colspan="5" class="text-center">No student data available</td>
  </tr>
        </tbody>
      </table>



      <!-- Payment Modal -->
<div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="paymentModalLabel">
          {{ selectedStudent?.student.first_name }} {{ selectedStudent?.student.last_name }} - Payments
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div v-if="selectedStudent && selectedStudent.payments.length > 0" class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="table-light">
              <tr>
                <th>Date</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in selectedStudent.payments" :key="payment.id">
                <td>{{ payment.payment_date }}</td>
                <td>{{ payment.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="text-center text-muted">
          No payments available
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


      <nav v-if="pagination.total > perPage" class="mt-3">
  <ul class="pagination pagination-sm flex-wrap justify-content-center" style="overflow-x:auto; white-space:nowrap;">
    <li class="page-item" :class="{ disabled: currentPage === 1 }">
      <a class="page-link bg-light" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
    </li>

    <li 
      class="page-item" 
      v-for="page in pagination.last_page" 
      :key="page" 
      :class="{ active: currentPage === page }"
    >
      <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
    </li>

    <li class="page-item" :class="{ disabled: currentPage === pagination.last_page }">
      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
    </li>
  </ul>
</nav>





      </div>
    </div>
    </div>
  </template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      studentItems: [],
      selectedInstitute: "",
      institutes: [],
      selectedSubject: "",
      subjects: [],
      selectedGrade: "",
      grades: [],
      selectedDateFilter: "last_month",
      searchQuery: "",
      last12Months: [],
      loading: false,
      totalAllPayments: 0, // Store total payments
    totalFilteredPayments: 0, // Store filtered payments
    allStudentItemCount: 0, // Store all student items count
    filteredStudentItemCount: 0, // Store filtered student items count
    currentPage: 1,
perPage: 2,
pagination: [],
    selectedStudent: null,

    };
  },
  methods: {
    openPaymentModal(item) {
    this.selectedStudent = item;
  },
    generateLast12Months() {
    const months = [];
    const currentDate = new Date();
    for (let i = 0; i < 12; i++) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      months.push({ 
        label: `${year} ${month}`, 
        value: `${year}-${String(date.getMonth() + 1).padStart(2, '0')}` 
      });
    }
    this.last12Months = months;
  },
    fetchStudentData() {
      const teacherId = localStorage.getItem('teacher_id');
      this.loading = true;

      axios.get('/students-for-teacher-payment', {
        headers: { teacher_id: teacherId },
        params: {
          institute_id: this.selectedInstitute,
          subject_id: this.selectedSubject,
          grade_id: this.selectedGrade,
          date_filter: this.selectedDateFilter,
          search: this.searchQuery,
          page: this.currentPage,
    per_page: this.perPage
        }
      })
      .then(response => {
        // this.studentItems = response.data;
        this.studentItems = response.data.items; // Student items
        this.pagination = response.data.pagination;
    this.totalAllPayments = response.data.total_all_payments; // Total all payments
    this.totalFilteredPayments = response.data.total_filtered_payments; // Total filtered payments
    this.allStudentItemCount = response.data.all_student_item_count; // All student item count
    this.filteredStudentItemCount = response.data.filtered_student_item_count; // Filtered student item count
      })
      .catch(error => {
        console.error('Error fetching student data:', error);
      })
      .finally(() => {
        this.loading = false; // Hide spinner once complete
      });
    },
    async fetchInstitutes() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-institutes", {
          teacher_id: teacherId,
        });
        this.institutes = response.data;
      } catch (error) {
        console.error("Failed to fetch institutes:", error);
      }
    },

    async fetchSubjects() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-subjects", {
          teacher_id: teacherId,
        });
        this.subjects = response.data;
      } catch (error) {
        console.error("Failed to fetch subjects:", error);
      }
    },

    async fetchGrades() {
      const teacherId = localStorage.getItem("teacher_id");
      try {
        const response = await axios.post("/get-teacher-teach-grade", {
          teacher_id: teacherId,
        });
        this.grades = response.data;
      } catch (error) {
        console.error("Failed to fetch grades:", error);
      }
    },
    changePage(page) {
  if (page > 0 && page <= this.pagination.last_page) {
    this.currentPage = page;
    this.fetchStudentData();
  }
},
  },
  mounted() {
    this.fetchStudentData(); // Fetch student data when component is mounted
    this.fetchInstitutes();
    this.fetchSubjects();
    this.fetchGrades();
    this.generateLast12Months();
  },
  watch: {
    selectedInstitute() {
      this.fetchStudentData();
    },
    selectedSubject() {
      this.fetchStudentData();
    },
    selectedGrade() {
      this.fetchStudentData();
    },
    selectedDateFilter() {
      this.fetchStudentData();
    },
    searchQuery() {
      this.fetchStudentData(); // Triggers when typing
    },
  },
};
</script>


<style>
.mobile{
  display: none;
}

@media (max-width: 768px) {
  .desktop{
    display: none;
  }

  .mobile{
  display: block;
}
  table.table td, table.table th {
    padding: 0.25rem;
    font-size: 0.75rem;
  }

    .table-responsive {
      max-width: 82.5vw;
    overflow-x: auto;
  }


  .pagination {
    flex-wrap: nowrap;      /* Prevent wrapping */
    overflow-x: auto;       /* Scroll horizontally */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on mobile */
  }
  .pagination .page-item {
    flex: 0 0 auto;         /* Keep items from shrinking */
  }
  .page-link {
    font-size: 0.85rem;     /* Slightly smaller buttons */
    padding: 0.3rem 0.6rem; /* Compact padding */
  }
}




</style>
  